import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import JobAlertModal from '../ModalWindows/JobAlertModal/JobAlertModal';
import { actionTypes } from './types';
import { jobAlerts } from '../../../utils/constants';
import { Menu } from '../Form/Menu/Menu';
import { createNewJobAlert, getAllJobAlerts } from '../../../actions/jobAlerts';
import { getValuesByKey } from '../../../utils/helpers';

function JobAlerts({ filters }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const functionsDirections = useSelector((state) => state.constFromApi.functionsDirections);
  const industries = useSelector((state) => state.constFromApi.industries);
  const alerts = useSelector((state) => state.jobAlerts.alerts);

  const createHandler = (data) => dispatch(createNewJobAlert(data));

  const modalWindowCreators = {
    CREATE: () => ({
      type: actionTypes.CREATE,
      title: 'Create Alert',
      confirmHandler: createHandler,
      data: { empty: true }
    }),
    CLOSE: () => ({
      type: actionTypes.CLOSE,
      title: '',
      confirmHandler: () => {},
      data: {}
    })
  };

  const [open, setOpen] = useState(false);

  const setFromSearchAction = () => {
    const key = 'label';
    const prepearedData = {
      UserId: localStorage.getItem('UserId'),
      Keyword: filters?.field || '',
      JobAlertIndustries: filters?.industry
        ? getValuesByKey(filters?.industry, key, industries, key).map((industry) => ({
            IndustryId: industry.IndustryId
          }))
        : [],
      JobAlertJobFunctions: filters?.function
        ? getValuesByKey(filters?.function, key, functionsDirections, key).map((functionItem) => ({
            JobFunctionId: functionItem.JobFunctionId
          }))
        : [],
      JobAlertContractTypes: filters?.contract_type || [],
      Frequency: 'daily',
      Location: filters?.location || '',
      IsActive: true,
      Id: open?.data?.Id
    };

    createHandler(prepearedData);
  };

  const handleJobAlerts = (action) => {
    switch (action) {
      case actionTypes.CREATE:
        return setOpen(modalWindowCreators.CREATE());
      case actionTypes.SET:
        return setFromSearchAction();
      case actionTypes.VIEW:
        return navigate('/my-profile?tab=alerts');
      default:
        return null;
    }
  };

  useEffect(() => {
    // dispatch(getAllJobAlerts());
  }, []);

  return (
    <>
      <Menu options={jobAlerts(t, alerts.length, 5)} onMenuSelect={handleJobAlerts} isArrowIcon>
        {t('jobs.alerts.label')}
      </Menu>
      <JobAlertModal
        type={open.type}
        title={open.title}
        closeHandler={() => setOpen(modalWindowCreators.CLOSE())}
        confirmHandler={(data) => {
          open.confirmHandler(data);
          setOpen(modalWindowCreators.CLOSE());
        }}
        data={open.data}
      />
    </>
  );
}

export default JobAlerts;
